import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Corte = (props) => (
  <SvgIcon
    width="20.174"
    height="16.137"
    viewBox="0 0 20.174 16.137"
    {...props}
  >
    <g transform="translate(-391.793 -7.793)">
      <g transform="translate(393 9)">
        <path d="M14,0V14H0Z" />
        <path d="M 12 4.82841968536377 L 4.82841968536377 12 L 12 12 L 12 4.82841968536377 M 14 0 L 14 14 L 0 14 L 14 0 Z" />
      </g>
      <g transform="translate(393 9.167)">
        <path d="M0,0H9.833L0,9.833Z" />
        <path d="M 1.999997138977051 1.999997138977051 L 1.999997138977051 5.00495719909668 L 5.00495719909668 1.999997138977051 L 1.999997138977051 1.999997138977051 M -2.86102294921875e-06 -2.86102294921875e-06 L 9.833376884460449 -2.86102294921875e-06 L -2.86102294921875e-06 9.833376884460449 L -2.86102294921875e-06 -2.86102294921875e-06 Z" />
      </g>
    </g>
  </SvgIcon>
);
export default Corte;



// WEBPACK FOOTER //
// ./src/common/icons/Corte/index.tsx